(function() {
  'use strict';
  angular.module('common')
  .directive('scrollToErrorForm', ['$window', function($window) {
    return {
      restrict: 'A',
      require: 'form',
      link: function($scope, elem) {
        elem.on('submit', function() {
          if (elem[0].querySelector('.form-errors:not(.ng-hide)')) {
            $(window).scrollTop(0);
          }
          var firstInvalid = $(elem[0]).find(':not(form, [ng-form]).ng-invalid');
          if (firstInvalid && firstInvalid.length) {
            firstInvalid[0].focus();
          }
        });
      }
    };
  }]);
})();